module.exports = __webpack_public_path__ + "img/logo.42fe99c6.png";